import React from 'react'

function TerritoryBreak({ territory }: { territory: string }) {
    return (
      <div className="bg-slate-400 text-xl font-bold capitalize text-white">
        <div className="w-fit rounded-br-xl py-1 pl-2 pr-10">{territory}</div>
      </div>
    );
  }

export default TerritoryBreak